import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { navigate } from "gatsby-link"
import { useLocation } from "@reach/router"

export const navigateTo = path => {
  let isExternal = path.startsWith("http")
  if (isExternal) {
    window.location.href = path; 
  } else {
    navigate("/" + location.pathname.split("/")[1] + path)
  }
}

const LinkChoice = ({ to, children, ...props }) => {
  const location = useLocation()
  const isExternal = to.startsWith("http")

  if (isExternal) {
    return (
      <a href={to} target="_blank" rel="noreferrer" {...props}>
        {children}
      </a>
    )
  } else {
    return (
      <Link to={"/" + location.pathname.split("/")[1] + to} {...props}>
        {children}
      </Link>
    )
  }
}

LinkChoice.propTypes = {
  link: PropTypes.object.isRequired,
  to: PropTypes.string,
}

export default LinkChoice
